import { connect } from "react-redux"
import ReservationModal from "../../components/shop/reservation/modal"

const mapStateToProps = state =>({
  ...state.currentShop.reservation,
  players: state.entities.players,
  reservations: state.entities.reservations,
  allOptionsSelected: state.currentShop.reservation.reservationId && state.currentShop.reservation.currentPrice
})

const mapDispatchToProps = dispatch => ({
  onCancel: () => dispatch({type: "SHOP_RESERVATION_CANCEL"}),
  onSubmit: () => dispatch({type: "SHOP_RESERVATION_ADDED"}),
  onPlayerChanged: data => dispatch({type: "SHOP_RESERVATION_PLAYER_CHANGED", payload: data}),
  onSelectReservation: id => dispatch({type: "SHOP_RESERVATION_SELECTED", payload: {id}}),
})

export default connect(mapStateToProps, mapDispatchToProps)(ReservationModal)
